export default "__VITE_ASSET__CFFYYWci__"